__turbopack_context__.v({
  "item": "story-rail-module__uWg1la__item",
  "label": "story-rail-module__uWg1la__label",
  "own": "story-rail-module__uWg1la__own",
  "rail": "story-rail-module__uWg1la__rail",
  "track": "story-rail-module__uWg1la__track",
});
